import numberFormatter from "../../numberFormatter";

interface FormattedNumberProps {
	value: string | number | null | undefined;
}

export default function FormattedNumber({ value }: FormattedNumberProps) {
	if (value === null || value === undefined) return null;

	return <>{numberFormatter.format(Number(value))}</>;
}
